export const supportedLanguages = [
    { code: 'es', label: 'Español' },
    { code: 'en', label: 'Inglés' },
    { code: 'fr', label: 'Francés' },
    { code: 'it', label: 'Italiano' },
    { code: 'de', label: 'Alemán' },
    { code: 'jp', label: 'Japonés' },
    { code: 'pt', label: 'Portugues' },
];
